import { ApiGpdGpdsListRequest, GPD } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { getSearchKey } from "@/components/searchbox";
import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useQueryPagination } from "@/hooks/use-pagination";
import { KEY_ADDON_MAP, useRouterTableData } from "@/hooks/use-router-table-data";
import { useGpdListQuery } from "@/queries/query-gpd";

import { FilterWrapper } from "../../components/filter-wrapper";

import { GpdFilters } from "./components/gpd-filters";
import { GpdReportTable } from "./components/gpd-report-table";
import { gpdInformation } from "./types";

export const columnDefinitions: ColumnDefinition<GPD>[] = gpdInformation.map(
  ({ key, label }, index) => ({
    title: label,
    renderFunction: (row) =>
      renderDefault(row[key], index === 0 ? `/gpd/startregistratie/${row.uuid}/` : undefined),
    width: "1fr",
  })
);

export function GpdTable() {
  const {
    page,
    setPage,
    searchField: _searchField,
    searchString,
    setSearchField,
    setSearchString,
  } = useRouterTableData({ keyAddon: KEY_ADDON_MAP.GPD });
  const searchField =
    (_searchField as keyof ApiGpdGpdsListRequest | undefined) || getSearchKey(gpdInformation[0]);
  const queryParams: ApiGpdGpdsListRequest = {
    page,
    ...(searchField ? { [searchField]: searchString } : {}),
  };
  const { data: gpdList, isLoading } = useGpdListQuery(queryParams);
  const paginationProps = useQueryPagination({
    queryResponse: gpdList,
    page,
    setPage,
  });

  return (
    <>
      <FilterWrapper>
        <GpdFilters {...{ searchField, searchString, setSearchField, setSearchString }} />
      </FilterWrapper>
      <TableOverview
        isLoading={isLoading}
        rowAccordion={({ uuid }: GPD) => {
          if (!uuid) return null;
          return <GpdReportTable gpd={uuid} />;
        }}
        tableData={gpdList?.results || []}
        columnDefinitions={columnDefinitions}
        paginationProps={paginationProps}
      />
    </>
  );
}
